import {ContentFilter} from './content-filter';

export class ContentListRequest {
  search: string;
  limit: number;
  offset: number;
  sortProp: string;
  sortDir: string;
  filter: ContentFilter;

  constructor(search: string, limit: number, offset: number, sortProp: string, sortDir: string, filter: ContentFilter) {
    this.search = search;
    this.limit = limit;
    this.offset = offset;
    this.sortProp = sortProp;
    this.sortDir = sortDir;
    this.filter = filter;
  }
}
